if (!customElements.get('cat-wall-pairings')) {
  class CatWallPairings extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const {signal} = this.abort;
      this.currentProduct = Number(this.dataset.currentProduct);
      this.currentVariants = JSON.parse(this.querySelector('[data-current-variants]').textContent);
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.bundles = JSON.parse(this.querySelector('[data-bundle-data]').textContent);
      const priority = ['NC011', 'NC016', 'NC015', 'NC041', 'NC009'];
      const rank = scene => {const index = priority.indexOf(scene.dataset.sku); return index < 0 ? priority.length : index;};
      const position = scene => scene.dataset.order === '' ? Infinity : Number(scene.dataset.order);
      this.scenes = [...this.querySelectorAll('[data-scene]')].sort((a, b) => rank(a) - rank(b) || position(a) - position(b));
      this.modal = this.querySelector('[data-pairings-modal]');
      this.sharedPurchase = this.modal.querySelector('[data-unit-purchase]');
      this.setPurchase = this.modal.querySelector('petomg-set-purchase');
      this.modal.id = `CWPairingsModal-${this.dataset.sectionId}`;
      this.modalOwner = this.modal.parentNode;
      document.body.append(this.modal);
      this.navigation = this.querySelector('.cwp-navigation');
      this.unitTemplates = new Map([...this.querySelectorAll('[data-unit-card]')].map(node => [Number(node.dataset.unitCard), node]));
      this.quantities ||= new Map();
      this.currentSku = this.scenes[0].querySelector('.cwp-marker').textContent.trim();
      this.querySelector('.cwp-tabs').replaceChildren();
      this.scenes.forEach((scene, index) => {
        const tab = document.createElement('button');
        tab.type = 'button'; tab.dataset.sceneIndex = String(index);
        tab.append(document.createTextNode(scene.dataset.sku));
        const label = document.createElement('span'); label.textContent = scene.dataset.label; tab.append(label);
      this.querySelector('.cwp-tabs').append(tab);
      });
      const initialIndex = this.scenes.findIndex(scene => scene.dataset.sku === this.detailsReturnGuard?.userScene);
      this.selectScene(initialIndex >= 0 ? initialIndex : 0);
      this.addEventListener('click', event => this.handleClick(event), {signal});
      this.addEventListener('keydown', event => {
        if (!event.target.matches('.cwp-photo') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.selectScene(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      this.addEventListener('pointerdown', event => {
        if (!event.target.closest('.cwp-photo') || event.target.closest('button')) return;
        this.swipe = {x: event.clientX, y: event.clientY};
      }, {signal});
      this.addEventListener('pointerup', event => {
        if (!this.swipe) return;
        const x = event.clientX - this.swipe.x, y = event.clientY - this.swipe.y; this.swipe = null;
        if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.4) this.selectScene(this.activeIndex + (x < 0 ? 1 : -1));
      }, {signal});
      this.addEventListener('pointercancel', () => { this.swipe = null; }, {signal});
      this.modal.addEventListener('click', event => this.handleModalClick(event), {signal});
      // Intercept before the native Modal close listener so zoom returns to its owning set.
      this.modal.addEventListener('click', event => {
        if (this.mode !== 'zoom' || (event.target !== this.modal && !event.target.closest('.js-close-modal'))) return;
        event.preventDefault(); event.stopImmediatePropagation(); this.showSetView();
      }, {signal, capture: true});
      this.modal.addEventListener('change', event => {
        if (!event.target.matches('input[name="quantity"]')) return;
        const productId = Number(event.target.closest('form').dataset.cwpProduct);
        if (productId) this.quantities.set(productId, event.target.value);
      }, {signal});
      this.modal.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.mode === 'zoom') {
          event.preventDefault(); event.stopPropagation(); this.showSetView(); this.escapeZoom = true;
        } else if (event.target.closest('.cwp-set-track') && ['ArrowRight', 'ArrowLeft'].includes(event.key)) {
          event.preventDefault(); this.movePhoto(event.key === 'ArrowRight' ? 1 : 0);
        }
      }, {signal});
      this.modal.addEventListener('keyup', event => {
        if (event.key === 'Escape' && this.activeOverlap?.panel?.isConnected) {
          event.preventDefault(); event.stopImmediatePropagation(); this.clearOverlap(true); return;
        }
        if (event.key === 'Escape' && this.escapeZoom) {event.stopImmediatePropagation(); this.escapeZoom = false;}
      }, {signal});
      document.addEventListener('on:product-form:prepare-cart-items', event => this.prepareAdd(event), {signal});
      if (!this.sharedPurchase) {
        for (const name of ['on:cart:add', 'on:line-item:change']) {
          document.addEventListener(name, event => {
            const form = event.target.closest?.('product-form')?.form;
            if (form && this.modal.contains(form) && form.dataset.cwpKind === 'unit' && form.dataset.afterAtc === 'stay') this.shakeCartIcon();
          }, {signal});
        }
      }
      if (this.dataset.detailsReturnRestore === 'true') {
        if (this.dataset.restoreDialogOnBack === 'true') {
          this.returnDialogObserver?.disconnect();
          this.returnDialogObserver = new MutationObserver(() => {
            // History traversal can switch the active entry before pagehide runs.
            const snapshot = history.state?.petomgPairingsReturn?.[this.dataset.sectionId];
            if (snapshot?.url === location.href && snapshot.product === this.currentProduct && this.detailsRestored
              && !this.detailsNavigation && !this.modal.hasAttribute('open') && document.visibilityState === 'visible') this.saveDetailsReturn();
          });
          this.returnDialogObserver.observe(this.modal,{attributes:true,attributeFilter:['open']});
        }
        window.addEventListener('pageshow', event => this.restoreDetailsReturn(event.persisted), {signal});
        window.addEventListener('pagehide', () => {
          const previous = history.state?.petomgPairingsReturn?.[this.dataset.sectionId];
          if (previous) {
            if (!this.detailsNavigation) this.saveDetailsReturn();
            this.closeForDetails();
            if (this.detailsNavigation) window.scrollTo({top:previous.pageY,behavior:'instant'});
          }
        }, {signal});
        this.restoreDetailsReturn(false);
      }
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.clearOverlap();
      this.confirmedOverlap = null;
      this.returnDialogObserver?.disconnect();
      this.detailsReturnGuard?.stop();
      cancelAnimationFrame(this.returnDialogFrame);
      this.modal?.classList.remove('cwp-modal--restoring');
      clearTimeout(this.cartFeedbackTimer);
      this.cartFeedbackIcon?.classList.remove('cwp-cart-added');
      if (this.modal?.hasAttribute('open')) this.modal.close();
      if (this.modal && this.modalOwner) this.modalOwner.append(this.modal);
    }

    shakeCartIcon() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const icon = document.getElementById('cart-icon');
      if (!icon) return;
      clearTimeout(this.cartFeedbackTimer);
      this.cartFeedbackIcon = icon;
      icon.classList.remove('cwp-cart-added');
      void icon.offsetWidth;
      icon.classList.add('cwp-cart-added');
      this.cartFeedbackTimer = setTimeout(() => icon.classList.remove('cwp-cart-added'), 1000);
    }

    saveDetailsReturn() {
      if (this.dataset.detailsReturnRestore !== 'true') return;
      // Keep this snapshot on the origin history entry; never add an extra Back step.
      const previous = history.state;
      if (previous !== null && (typeof previous !== 'object' || Array.isArray(previous))) return;
      const opened = this.modal.hasAttribute('open');
      const quantities = [...this.quantities];
      for (const input of this.modal.querySelectorAll('[data-pieces-content] input[name="quantity"]')) {
        const product = Number(input.closest('form').dataset.cwpProduct);
        const index = quantities.findIndex(([id]) => id === product);
        if (index < 0) quantities.push([product,input.value]); else quantities[index][1] = input.value;
      }
      const snapshot = {version:2, url:location.href, product:this.currentProduct,
        scene:this.scenes[this.activeIndex].dataset.sku,
        pageY:opened ? this.modal.scrollY : window.scrollY, quantities,
        dialogOpen:opened && this.mode === 'pieces',dialogY:(this.sharedPurchase?.querySelector('.pup__body')
          || this.modal.querySelector('.modal__window')).scrollTop,
        dialogFocus:Number(this.modal.querySelector('.cwp-unit:focus-within')?.dataset.unitId
          || this.modal.querySelector('.pup-unit:focus-within')?.dataset.unitProductId) || this.currentProduct};
      try {
        history.replaceState({...previous, petomgPairingsReturn:{...previous?.petomgPairingsReturn,
          [this.dataset.sectionId]:snapshot}}, '');
      } catch { /* Navigation remains usable if the browser refuses history storage. */ }
    }

    closeForDetails() {
      if (!this.modal.hasAttribute('open')) return;
      const pageY = this.modal.scrollY;
      this.modal.close();
      window.scrollTo({top:pageY,behavior:'instant'});
    }

    restoreDetailsReturn(persisted) {
      if (this.dataset.detailsReturnRestore !== 'true') return;
      const snapshot = history.state?.petomgPairingsReturn?.[this.dataset.sectionId];
      if (!snapshot || snapshot.version !== 2 || snapshot.url !== location.href || snapshot.product !== this.currentProduct) return;
      if (!persisted && (this.detailsRestored || performance.getEntriesByType('navigation')[0]?.type !== 'back_forward')) return;
      const index = this.scenes.findIndex(scene => scene.dataset.sku === snapshot.scene);
      if (index < 0 || !Array.isArray(snapshot.quantities) || !Number.isFinite(snapshot.pageY)) return;
      this.detailsRestored = true;
      this.returnDialogRestored = false;
      this.detailsNavigation = false;
      for (const entry of snapshot.quantities) {
        if (Array.isArray(entry) && this.unitTemplates.has(entry[0]) && /^\d+$/.test(entry[1])) this.quantities.set(entry[0],entry[1]);
      }
      // The browser owns history scrolling. Never move the page when late resources finish.
      const guard = this.detailsReturnGuard;
      if (!persisted && !guard?.interacted && (!guard || performance.now() <= guard.deadline)) this.selectScene(index);
      if (persisted) this.restoreReturnDialog(snapshot,true);
    }

    restoreReturnDialog(snapshot,persisted) {
      if (this.dataset.restoreDialogOnBack !== 'true' || snapshot.dialogOpen !== true
        || !Number.isFinite(snapshot.dialogY) || document.visibilityState !== 'visible'
        || this.modal.hasAttribute('open') || document.body.classList.contains('fixed')
        || !customElements.get('modal-dialog') || !customElements.get('product-form')) return;
      const guard = this.detailsReturnGuard;
      if (!persisted && (!guard?.positioned || guard.interacted || performance.now() > guard.deadline)) return;
      const scene = this.scenes[this.activeIndex];
      if (scene.dataset.sku !== snapshot.scene) return;
      const opener = scene.querySelector('[data-open-pieces]');
      this.modal.classList.add('cwp-modal--restoring');
      if (persisted && this.mode === 'pieces' && this.modal.querySelector('[data-pieces-content] form')) {
        // Reuse retained BFCache DOM; do not clone forms or attach their listeners twice.
        this.modal.open(opener);
        this.sharedPurchase?.loadCart();
      } else this.openPieces(opener);
      const link = [...this.modal.querySelectorAll('.cwp-unit, .pup-unit')]
        .find(card => Number(card.dataset.unitId || card.dataset.unitProductId) === snapshot.dialogFocus)
        ?.querySelector('.cwp-unit__details, .pup-unit__details');
      link?.focus({preventScroll:true});
      (this.sharedPurchase?.querySelector('.pup__body') || this.modal.querySelector('.modal__window')).scrollTop = Math.max(0,snapshot.dialogY);
      if (!persisted && performance.now() > guard.deadline) {
        this.closeForDetails();
        this.modal.classList.remove('cwp-modal--restoring');
        return;
      }
      this.returnDialogRestored = true;
      cancelAnimationFrame(this.returnDialogFrame);
      this.returnDialogFrame = requestAnimationFrame(() => {
        this.returnDialogFrame = 0;
        this.modal.classList.remove('cwp-modal--restoring');
      });
    }

    selectScene(index) {
      this.activeIndex = (index + this.scenes.length) % this.scenes.length;
      this.scenes.forEach((scene, i) => { scene.hidden = i !== this.activeIndex; });
      this.querySelectorAll('[data-scene-index]').forEach(tab => tab.setAttribute('aria-pressed', String(Number(tab.dataset.sceneIndex) === this.activeIndex)));
      this.navigation.querySelector('[data-scene-count]').textContent = `${this.activeIndex + 1} / ${this.scenes.length}`;
      this.scenes[this.activeIndex].querySelector('.cwp-scene__gallery').append(this.navigation);
      const tabs = this.navigation.querySelector('.cwp-tabs');
      const active = tabs.querySelector(`[data-scene-index="${this.activeIndex}"]`);
      if (active) tabs.scrollTo({left: tabs.scrollLeft + active.getBoundingClientRect().left - tabs.getBoundingClientRect().left
        - (tabs.clientWidth - active.clientWidth) / 2, behavior: 'instant'});
    }

    handleClick(event) {
      const button = event.target.closest('button'); if (!button) return;
      if (button.hasAttribute('data-direction')) this.selectScene(this.activeIndex + Number(button.dataset.direction));
      else if (button.hasAttribute('data-scene-index')) this.selectScene(Number(button.dataset.sceneIndex));
      else if (button.hasAttribute('data-open-pieces')) this.openPieces(button);
      else if (button.hasAttribute('data-open-set')) this.openSet(button);
    }

    openPieces(opener) {
      this.clearOverlap();
      this.confirmedOverlap = null;
      this.mode = 'pieces';
      const scene = this.scenes[this.activeIndex];
      const units = JSON.parse(scene.querySelector('[data-pieces-order]').content.textContent);
      const ordered = [this.currentProduct, ...units.filter(id => id !== this.currentProduct)];
      if (this.sharedPurchase) {
        this.showView('pieces');
        this.modal.setAttribute('aria-labelledby', `PUPTitle-${this.dataset.sectionId}`);
        this.sharedPurchase.open({opener, orderedIds: ordered, templates: this.unitTemplates});
        this.modal.querySelector('.pup__body').scrollTop = 0;
        if (opener.hasAttribute('data-focus-current')) {
          this.modal.querySelector('[data-current] button[name="add"]')?.focus({preventScroll: true});
        }
        return;
      }
      const content = this.modal.querySelector('[data-pieces-content]'); content.replaceChildren();
      for (const id of ordered) {
        const template = this.unitTemplates.get(id);
        if (template) content.append(template.content.cloneNode(true));
      }
      for (const input of content.querySelectorAll('input[name="quantity"]')) {
        const quantity = this.quantities.get(Number(input.closest('form').dataset.cwpProduct));
        if (quantity) input.value = quantity;
      }
      this.modal.querySelector('[data-modal-eyebrow]').textContent = `${scene.dataset.sku} · ${this.copy.pieces}`;
      this.modal.querySelector('[data-pieces-title]').hidden = false;
      this.modal.setAttribute('aria-labelledby', `CWPPiecesTitle-${this.dataset.sectionId}`);
      this.showView('pieces'); this.modal.open(opener);
      this.modal.querySelector('.modal__window').scrollTop = 0;
      if (opener.hasAttribute('data-focus-current')) {
        this.modal.querySelector('[data-current] button[name="add"]')?.focus({preventScroll: true});
      }
    }

    openSet(opener) {
      this.clearOverlap();
      this.confirmedOverlap = null;
      const scene = this.scenes[this.activeIndex];
      const content = this.modal.querySelector('[data-set-content]');
      content.replaceChildren(scene.querySelector('[data-set-view]').content.cloneNode(true));
      this.modal.querySelector('[data-modal-eyebrow]').textContent = this.copy.completeSet;
      this.modal.querySelector('[data-pieces-title]').hidden = true;
      this.showSetView(); this.modal.open(opener);
      this.setPurchase?.activate(scene.dataset.setVariantId, scene.dataset.sku);
      this.getSetScroller().scrollTop = 0;
      this.track = content.querySelector('.cwp-set-track');
      this.track.addEventListener('scroll', () => this.syncPhoto(), {passive: true, signal: this.abort.signal});
      this.movePhoto(0, 'instant');
    }

    showView(name) {
      this.modal.dataset.mode = name;
      this.modal.querySelector('.cwp-modal__header').hidden = name === 'zoom' || (name === 'pieces' && !!this.sharedPurchase);
      this.modal.querySelector('[data-pieces-view]').hidden = name !== 'pieces';
      (this.setPurchase || this.modal.querySelector('[data-set-content]')).hidden = name !== 'set';
      this.modal.querySelector('[data-zoom-view]').hidden = name !== 'zoom';
      if (this.modal.hasAttribute('open') && typeof window.trapFocus === 'function') window.trapFocus(this.modal);
    }

    getSetScroller() {
      return this.setPurchase?.querySelector('[data-set-content]') || this.modal.querySelector('.modal__window');
    }

    showSetView() {
      const zoomOpener = this.mode === 'zoom' ? this.zoomOpenedBy : null;
      this.mode = 'set'; this.showView('set');
      this.modal.removeAttribute('aria-label');
      this.modal.setAttribute('aria-labelledby', `CWPSetTitle-${this.dataset.sectionId}`);
      if (zoomOpener) {
        this.movePhoto(1, 'instant'); this.getSetScroller().scrollTop = this.setScrollTop || 0;
        zoomOpener.focus({preventScroll: true});
      }
    }

    movePhoto(index, behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth') {
      const track = this.modal.querySelector('.cwp-set-track');
      if (!track) return;
      track.scrollTo({left: index * track.clientWidth, behavior});
      this.syncPhoto();
    }

    syncPhoto() {
      const track = this.modal.querySelector('.cwp-set-track');
      if (!track?.clientWidth) return;
      const index = Math.round(track.scrollLeft / track.clientWidth);
      this.modal.querySelectorAll('[data-photo]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.photo) === index)));
      this.modal.querySelector('[data-photo-count]').textContent = `${index + 1} / 2`;
      this.modal.querySelector('[data-enlarge]').hidden = index !== 1;
    }

    openZoom(opener) {
      this.zoomOpenedBy = opener;
      this.setScrollTop = this.getSetScroller().scrollTop;
      const source = this.modal.querySelector('.cwp-dimension-open img');
      const image = this.modal.querySelector('[data-zoom-image]'); image.src = source.currentSrc || source.src; image.alt = source.alt;
      image.width = source.naturalWidth || 3200; image.height = source.naturalHeight || 3200;
      this.mode = 'zoom'; this.zoom = 2; this.showView('zoom'); this.applyZoom();
      this.modal.querySelector('.modal__window').scrollTop = 0;
      this.modal.removeAttribute('aria-labelledby'); this.modal.setAttribute('aria-label', this.copy.dimensions);
      this.modal.querySelector('.cwp-zoom-canvas').scrollTo(0, 0);
      this.modal.querySelector('[data-zoom-back]').focus({preventScroll: true});
    }

    applyZoom() {
      this.modal.querySelector('[data-zoom-image]').style.width = `${this.zoom * 100}%`;
      this.modal.querySelector('[data-zoom-percent]').textContent = `${Math.round(this.zoom * 100)}%`;
      this.modal.querySelector('[data-zoom-step="-0.5"]').disabled = this.zoom <= 1;
      this.modal.querySelector('[data-zoom-step="0.5"]').disabled = this.zoom >= 4;
    }

    handleModalClick(event) {
      if (!this.modal.hasAttribute('open')) {
        this.clearOverlap();
        this.confirmedOverlap = null;
        return;
      }
      const details = event.target.closest('.cwp-unit__details, .pup-unit__details, .pup-unit__image');
      if (details && this.dataset.detailsReturnRestore === 'true' && !event.defaultPrevented
        && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey
        && (!details.target || details.target === '_self') && !details.hasAttribute('download')) {
        const destination = new URL(details.href);
        if (destination.origin === location.origin && this.mode === 'pieces') {
          this.saveDetailsReturn();
          this.detailsNavigation = true;
          this.closeForDetails();
        }
      }
      if (event.target.closest('.js-quick-add')) {this.modal.close(); return;}
      const button = event.target.closest('button'); if (!button) return;
      if (button.classList.contains('js-close-modal')) return;
      else if (button.hasAttribute('data-photo')) this.movePhoto(Number(button.dataset.photo));
      else if (button.hasAttribute('data-zoom')) this.openZoom(button);
      else if (button.hasAttribute('data-zoom-step')) {this.zoom = Math.max(1, Math.min(4, this.zoom + Number(button.dataset.zoomStep))); this.applyZoom();}
      else if (button.hasAttribute('data-zoom-back')) this.showSetView();
    }

    clearOverlap(restoreFocus = false) {
      const current = this.activeOverlap;
      current?.panel.remove();
      this.activeOverlap = null;
      if (restoreFocus) current?.form.querySelector('[name="add"]')?.focus({preventScroll: true});
    }

    showOverlap(form, kind, message) {
      this.clearOverlap();
      const panel = document.createElement('div');
      panel.className = 'cwp-overlap';
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-label', this.copy.overlapTitle);
      panel.setAttribute('aria-live', 'polite');
      const title = document.createElement('strong');
      title.className = 'cwp-overlap__title';
      title.textContent = this.copy.overlapTitle;
      const copy = document.createElement('p');
      copy.textContent = message;
      const actions = document.createElement('div');
      actions.className = 'cwp-overlap__actions';
      const cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'cwp-overlap__cancel';
      cancel.textContent = this.copy.overlapCancel;
      const confirm = document.createElement('button');
      confirm.type = 'button';
      confirm.className = 'cwp-overlap__confirm';
      confirm.textContent = kind === 'set' ? this.copy.overlapAddSet : this.copy.overlapAddUnit;
      actions.append(cancel, confirm);
      panel.append(title, copy, actions);
      const host = form.closest('product-form') || form;
      if (kind === 'set' || !this.modal.contains(form)) host.before(panel);
      else host.after(panel);
      this.activeOverlap = {panel, form};
      cancel.addEventListener('click', () => {
        this.confirmedOverlap = null;
        this.clearOverlap(true);
      });
      confirm.addEventListener('click', () => {
        if (this.activeOverlap?.panel !== panel || !form.isConnected) return;
        this.confirmedOverlap = {form, signature: panel.dataset.signature};
        this.clearOverlap();
        form.requestSubmit();
      });
      panel.scrollIntoView({block: 'nearest'});
      cancel.focus({preventScroll: true});
      return panel;
    }

    prepareAdd(event) {
      const form = event.target, detail = event.detail;
      if (form.closest('quick-add-drawer') || detail.cwpCheckInstalled) return;
      const ownForm = this.modal.contains(form);
      const mainForm = form.matches('.js-product-form-main') && this.currentVariants.includes(Number(detail.primaryVariantId));
      if (!ownForm && !mainForm) return;
      detail.cwpCheckInstalled = true;
      const kind = form.dataset.cwpKind || 'unit';
      const stayAfterAdd = ownForm &&
        ((kind === 'unit' && (this.dataset.stayAfterUnitAdd === 'true' || !!form.closest('petomg-unit-purchase')))
          || (kind === 'set' && !!form.closest('petomg-set-purchase')));
      if (stayAfterAdd) form.dataset.afterAtc = 'stay';
      else if (ownForm && form.dataset.afterAtc === 'stay') delete form.dataset.afterAtc;
      const productId = Number(form.dataset.cwpProduct || this.currentProduct);
      const sku = form.dataset.cwpSku || this.currentSku;
      const previousCheck = detail.beforeAdd, previousSuccess = detail.afterAdd;
      detail.beforeAdd = async cart => {
        if (typeof previousCheck === 'function' && await previousCheck(cart) === false) {
          this.confirmedOverlap = null;
          return false;
        }
        let overlap;
        let message;
        if (kind === 'set') {
          const bundle = this.bundles.find(set => set.id === productId);
          overlap = cart.items.filter(item => bundle?.units.includes(item.product_id) && item.quantity > 0);
          message = this.copy.setWarning.replace('[items]', [...new Set(overlap.map(item => item.sku || item.product_title))].join(', '));
        } else {
          const sets = this.bundles.filter(set => set.units.includes(productId));
          overlap = cart.items.filter(item => sets.some(set => set.id === item.product_id) && item.quantity > 0);
          message = this.copy.unitWarning.replaceAll('[sku]', sku);
        }
        if (!overlap.length) {
          this.confirmedOverlap = null;
          this.clearOverlap();
          return true;
        }
        const signature = JSON.stringify([kind, productId, form.querySelector('[name="quantity"]')?.value,
          overlap.map(item => `${item.key || item.variant_id || item.product_id}:${item.quantity}`).sort()]);
        if (this.confirmedOverlap?.form === form && this.confirmedOverlap.signature === signature) {
          this.confirmedOverlap = null;
          this.clearOverlap();
          return true;
        }
        this.confirmedOverlap = null;
        this.showOverlap(form, kind, message).dataset.signature = signature;
        return false;
      };
      detail.afterAdd = async data => {
        if (typeof previousSuccess === 'function') await previousSuccess(data);
        if (!stayAfterAdd && this.modal.hasAttribute('open')) this.modal.close();
      };
    }
  }
  customElements.define('cat-wall-pairings', CatWallPairings);
}
